import React, { useState } from 'react';
import DefaultLayout from "../layout/DefaultLayout";
import {
  Box,
  Button,
  TextField,
  Typography,
  CssBaseline,
  Paper,
  Grid,
  Link,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useAuth } from "../Auth/AuthProvider";
import { useNavigate } from 'react-router-dom';
import { loginAPI } from '../Conections/LogConections';

const theme = createTheme();

export default function Login() {
  
  const auth = useAuth();
  const goTo = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorResponse, setErrorResponse] = useState("");

  React.useEffect(() => {
    if (auth.isAuthenticated) {
      goTo("/dashboard");
    }
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      const response = await loginAPI(email, password);
      if (response !== 403 && response !== 500) {
        auth.saveToken(response.accessToken);
        auth.saveAuth(true);
        setErrorResponse("");
        goTo("/dashboard");
      }
      else {
        setErrorResponse("Error of the authentication");
      }
    } catch (error) {
      setErrorResponse("System Error");
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <DefaultLayout ubication={1} />
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(to right, #0066ff, #33ccff)',
        }}
      >
        <CssBaseline />
        <Paper
          elevation={6}
          sx={{
            padding: 4,
            width: 400,
            borderRadius: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography variant="h5">Log In</Typography>
          <img src="/logo192.png" alt="Mi Imagen"/>
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              label="Email address"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              label="Password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2, backgroundColor: '#0066ff' }}
            >
              Log In
            </Button>
          </Box>
        </Paper>
      </Box>
    </ThemeProvider>
  );
}


/*import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  CssBaseline,
  Paper,
  Grid,
  Link,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useAuth } from "../Auth/AuthProvider";
import { useNavigate } from 'react-router-dom';
import { loginAPI } from '../Conections/LogConections';

const theme = createTheme();

export default function Login() {

  const auth = useAuth();
  const goTo = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorResponse, setErrorResponse] = useState("");

  React.useEffect(() => {
    if (auth.isAuthenticated) {
      goTo("/dashboard");
    }
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      const response = await loginAPI(email, password);
      if (response !== 403 && response !== 500) {
        auth.saveToken(response.accessToken);
        auth.saveAuth(true);
        setErrorResponse("");
        goTo("/dashboard");
      }
      else {
        setErrorResponse("Error of the authentication");
      }
    } catch (error) {
      setErrorResponse("System Error");
    }
  }

  const showpage = (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ height: '100vh' }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: 'url(/placeholder.svg?height=1080&width=1920)',
            backgroundRepeat: 'no-repeat',
            backgroundColor: (t) =>
              t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'primary.main',
                color: 'primary.contrastText',
                width: 56,
                height: 56,
                borderRadius: '50%',
                mb: 2,
                marginBottom:10
              }}
            >
              <img src="/logo192.png" alt="Mi Imagen"
              />
            </Box>
            <Typography component="h1" variant="h5">
              Iniciar sesión
            </Typography>
            {!!errorResponse && <div className="errorMessage">{errorResponse}</div>}
            <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Correo electrónico"
                name="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Contraseña"
                type="password"
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Recordarme"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Iniciar sesión
              </Button>
              <Grid container>
                <Grid item xs>
                  <Link href="/forgotpassword" variant="body2">
                    ¿Olvidaste tu contraseña?
                  </Link>
                </Grid>
                <Grid item>
                  <Link href="/signup" variant="body2">
                    Regístrase
                  </Link>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );

  return showpage;
}
*/